import { render, staticRenderFns } from "./FileInputBox.vue?vue&type=template&id=5651984e&scoped=true"
import script from "./FileInputBox.vue?vue&type=script&lang=js"
export * from "./FileInputBox.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./FileInputBox.vue?vue&type=style&index=0&id=5651984e&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5651984e",
  null
  ,true
)

export default component.exports